function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
/**
 * Formulas menu: list of saved formulas to choose from
 */
// eslint-disable-next-line no-restricted-imports
import * as React from 'react';
import clsx from 'clsx';
import { ItemClickEvent, Section, SectionItem } from 'common/components/items-menu/types';
import { withStyles } from 'common/util/react';
import { getResolvedFormulaEntry } from 'common/util/formulas';
import { ContextPanelData } from 'common/widgets/context-panel/types';
import { FeatureGate, Permission } from 'common/report/constants';
import { userCookieUtils } from 'common/report/util/user-identity-from-cookie';
import { getProjectId, getWorkspaceId } from 'common/report/util';
import { ButtonReact } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
import { ItemsMenuReact } from 'common/components/items-menu';
import { SkeletonListReact } from 'common/components/skeleton-list';
import { SkeletonListRowSize } from 'common/components/skeleton-list/types';
import { ContextPanelMenuReact } from 'common/widgets/context-panel/context-panel-menu';
import { useCurrentProject } from 'common/contexts/react/current-project-context';
import { useBehaviors } from 'common/contexts/react/behaviors-context';
import { useMetrics } from 'common/contexts/react/metrics-resource-context';
import { IronContextRegistry } from 'common/report/context-registry';
import { useTranslation } from 'common/i18n/hooks';
import { FormulaMetric } from 'app_api/projects/metrics/types';
import { ChildMenuInterface, ChildMenuItemsCache, ContextPanelRendererParams } from '../child-menu';
import { MenuSearchBar } from '../mixins/search-bar';
import { getChildMenuHeight } from '../utils/util';
import css from './index.inline.styl';
import { createContextPanelEventHandlers, generateFormulaContextPanelData } from './context-panel';
import { getFormulaSections } from './utils';
import { FormulaMenuItemValue } from './types';
interface FormulasMenuState {
  searchFilter: string;
}
interface FormulasMenuProps {
  keydownProxyEl?: HTMLElement;
  onSetKeydownProxyEl?: (el: HTMLElement) => void;
  onRender?: () => void;
  onCreate: (ev?: any) => void;
  onSelect: (item) => void;
  selected?: any;
  open?: boolean;

  // Below attributes read by ChildMenu methods
  eventNames?: string[];
  projectId?: number;
  readonly?: boolean;
  trackName?: string;
  userId?: number;
  workspaceId?: number;
}
const RECENT_ITEMS_SUB_KEY = "formula";
export class FormulasMenu extends React.PureComponent<FormulasMenuProps & Pick<IronContextRegistry, `currentProject` | `metrics` | `behaviors` | `i18n`>, FormulasMenuState> implements ChildMenuInterface {
  constructor() {
    var _userCookieUtils$getU;
    super(...arguments);
    _defineProperty(this, "childMenuRef", React.createRef<HTMLDivElement>());
    _defineProperty(this, "state", {
      searchFilter: ""
    });
    _defineProperty(this, "_cache", ChildMenuItemsCache.createCache(this.props.userId || ((_userCookieUtils$getU = userCookieUtils.getUserIdentityFromCookie()) === null || _userCookieUtils$getU === void 0 ? void 0 : _userCookieUtils$getU.id), Number(this.props.projectId || getProjectId()), "formulas-menu", Number(this.props.workspaceId || getWorkspaceId())));
  }
  componentDidUpdate() {
    var _this$props$onRender, _this$props;
    (_this$props$onRender = (_this$props = this.props).onRender) === null || _this$props$onRender === void 0 || _this$props$onRender.call(_this$props);
  }
  getRecentFormulas() {
    return this._cache.getRecentItems(RECENT_ITEMS_SUB_KEY, 3);
  }
  addRecentFormula(formula) {
    this._cache.addRecentItem(RECENT_ITEMS_SUB_KEY, formula, item => item.id);
  }
  canShare() {
    var _this$props$currentPr;
    return (_this$props$currentPr = this.props.currentProject.get()) === null || _this$props$currentPr === void 0 || (_this$props$currentPr = _this$props$currentPr.value) === null || _this$props$currentPr === void 0 ? void 0 : _this$props$currentPr.getFeatureGate(FeatureGate.Sharing);
  }
  canWriteMetrics() {
    var _this$props$currentPr2;
    return (_this$props$currentPr2 = this.props.currentProject.get()) === null || _this$props$currentPr2 === void 0 || (_this$props$currentPr2 = _this$props$currentPr2.value) === null || _this$props$currentPr2 === void 0 ? void 0 : _this$props$currentPr2.hasPermission(Permission.WriteMetrics);
  }
  handleClickCreate() {
    this.props.onCreate();
  }
  handleClickItem(_ref: ItemClickEvent<FormulaMenuItemValue>) {
    let {
      detail
    }: ItemClickEvent<FormulaMenuItemValue> = _ref;
    const {
      item
    } = detail;
    if (item.value.id) {
      this.addRecentFormula(item.value);
    }
    this.props.onSelect({
      detail: {
        item: item.value
      }
    });
  }
  getSections(): Array<Section<FormulaMenuItemValue>> {
    const recentFormulaMenuItems = this.getRecentFormulas();
    const savedFormulas = this.props.metrics.getAllValues().filter(metric => metric.type === "formula" && metric.can_view);
    const sections = getFormulaSections({
      recentFormulaMenuItems,
      savedFormulas: savedFormulas as FormulaMetric[]
    });
    return sections;
  }
  canOpenMenu() {
    return !this.props.readonly;
  }
  shouldCloseOnSelect() {
    return true;
  }
  selectedLabel() {
    const selected = this.props.selected;
    if (selected !== null && selected !== void 0 && selected.id) {
      var _getResolvedFormulaEn;
      return ((_getResolvedFormulaEn = getResolvedFormulaEntry({
        metricsResource: this.props.metrics,
        behaviorsResource: this.props.behaviors,
        formulaEntry: {
          event: selected
        }
      })) === null || _getResolvedFormulaEn === void 0 ? void 0 : _getResolvedFormulaEn.event.name) || (_ref2 => {
        let {
          t
        } = _ref2;
        return t("common.loading");
      });
    }
    return _ref3 => {
      let {
        t
      } = _ref3;
      return t("query-builder.select-formula");
    };
  }
  getSelectedHoverTooltipData() {
    var _this$props$selected;
    return this.getTooltipData((_this$props$selected = this.props.selected) === null || _this$props$selected === void 0 ? void 0 : _this$props$selected.id);
  }
  getTooltipData(id: number): ContextPanelData {
    var _this$props$currentPr3;
    return generateFormulaContextPanelData({
      id,
      metricsContext: this.props.metrics,
      currentProject: (_this$props$currentPr3 = this.props.currentProject) === null || _this$props$currentPr3 === void 0 || (_this$props$currentPr3 = _this$props$currentPr3.get()) === null || _this$props$currentPr3 === void 0 ? void 0 : _this$props$currentPr3.value,
      canWriteMetrics: this.canWriteMetrics(),
      canShare: this.canShare()
    });
  }
  render() {
    const {
      t
    } = this.props.i18n;
    const isLoading = this.props.metrics.isLoadingAll();
    const contextPanelEventHandlers = createContextPanelEventHandlers({
      availableContexts: {
        metrics: this.props.metrics
      }
    });
    return <div ref={this.childMenuRef} className={clsx("mp-formulas-menu", "mp-child-menu")} style={{
      height: getChildMenuHeight()
    }} data-sentry-component="FormulasMenu" data-sentry-source-file="index.tsx">
        {this.props.open && <>
            <MenuSearchBar ref={el => this.props.onSetKeydownProxyEl(el)} value={this.state.searchFilter} handleSearchInput={value => this.setState({
          searchFilter: value
        })} placeholder='Search...'>
              <ButtonReact className='create-custom-button' theme={ButtonTheme.Tertiary} icon={"plus"} onClick={() => this.handleClickCreate()}>
                {t("query-builder.create")}
              </ButtonReact>
            </MenuSearchBar>
            {isLoading ? <SkeletonListReact numRows={6} rowSize={SkeletonListRowSize.Large} className='mp-formulas-menu-skeleton-list' /> : <ItemsMenuReact className='mp-formulas-menu-items-menu' elref={"mainSelectionMenu"} emptyMessage={t("query-builder.no-items")} multiple={false} searchFilter={this.state.searchFilter} disableSearchSort disableSearchFilterMatchingParts disableFirstItemPadding onClick={ev => ev.stopPropagation()} onClickItem={ev => this.handleClickItem(ev)} onContextPanelHoverIn={contextPanelEventHandlers.onContextPanelHoverIn} onContextPanelHoverOut={contextPanelEventHandlers.onContextPanelHoverOut} onTooltipContextAction={contextPanelEventHandlers.onTooltipContextAction} onTooltipContextEditDescription={contextPanelEventHandlers.onTooltipContextEditDescription} sections={this.getSections()} keydownProxyEl={this.props.keydownProxyEl} contextPanelTransform={(item: SectionItem<FormulaMenuItemValue>) => {
          return item.value.id ? this.getTooltipData(item.value.id) : null;
        }} contextPanelPositionParentElement={this.childMenuRef.current} />}
          </>}
      </div>;
  }
}
_defineProperty(FormulasMenu, "contextPanelRenderer", (params: ContextPanelRendererParams) => {
  if (!params.tooltipData) {
    return null;
  }
  return <ContextPanelMenuReact {...params.contextPanelProps} data={params.tooltipData} elref='contextPanel' {...createContextPanelEventHandlers(params)} />;
});
export const FormulasMenuReact = withStyles(React.forwardRef<FormulasMenu, FormulasMenuProps>((props, ref) => {
  const currentProject = useCurrentProject();
  const metrics = useMetrics();
  const behaviors = useBehaviors();
  const i18n = useTranslation();
  return <FormulasMenu ref={ref} currentProject={currentProject} metrics={metrics} behaviors={behaviors} i18n={i18n} {...props} />;
}), css);